// extracted by mini-css-extract-plugin
export default {"contacts__list":"ContactNumbers_contacts__list__ONugD","contacts__link":"ContactNumbers_contacts__link__vT42P","contacts__icon":"ContactNumbers_contacts__icon__q-Au5"};